module.exports = __webpack_public_path__ + "img/renjy.da4f7b12.png";